import client, { axiosBaseUrl } from './client';
import { DictationApi } from 'woofwoof-api';

export const dictationApi = new DictationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);

export const dictationSessionApi = {
  createSession: () => dictationApi.dictationControllerCreateSession(),
};
